<div class="flex flex-row items-center v4-filter !pl-0 !pr-0">
  <div class="arrow prev px-[8px]" (click)="onPrevDate()">
    <i nz-icon nzType="left" nzTheme="outline"></i>
  </div>
  <host-range-picker
    class="v4-filter-style"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange()"
  ></host-range-picker>
  <div class="arrow next px-[8px]" (click)="onNextDate()">
    <i nz-icon nzType="right" nzTheme="outline"></i>
  </div>
</div>
